<template>
    <div class="card-block" id="login" >
        <div class="form-horizontal form-simple">
            <fieldset class="form-group position-relative has-icon-left mb-otstup mb-3" :class="{ 'form-group--error': $v.dataAuthorization.user.$error }" >
                <input type="text" v-model.trim="$v.dataAuthorization.user.$model"  class="form-control form-control-lg input-lg" id="user-name" :placeholder="$t('users.table.login')" >
                <div class="form-control-position">
                    <i class="icon-head"></i>
                </div>
                <div class="error" v-if="!$v.dataAuthorization.user.required">{{$t('errors.required')}}</div>              
            </fieldset>
            <fieldset class="form-group position-relative has-icon-left mb-otstup my-3" :class="{ 'form-group--error': $v.dataAuthorization.password.$error }">
                <input type="password" v-model.trim="$v.dataAuthorization.password.$model" class="form-control form-control-lg input-lg" id="user-password" :placeholder="$t('login.lbl.password')">
                <div class="form-control-position">
                    <i class="icon-key3"></i>
                </div>
                <div class="error" v-if="!$v.dataAuthorization.password.required">{{$t('errors.required')}}</div>                
            </fieldset> 
            <button ref="login" type="button" class="btn btn-auth btn-lg btn-block mb-3" @click="loginUser()"><i class="icon-unlock2"></i> {{ $t('login.btn.login') }}</button>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  name: "loginForm",
  props: {
  },
  data() {
    return {
        dataAuthorization: {
            user: null,
            password: null,
            ip: null,
        },
        submitStatus:null,
    }
  },
  validations: {
        dataAuthorization:{
            user:{
                required                
            },
            password:{
                required               
            }
        },
    },
  computed: {
  
  },
  methods: {
    loginUser(){
          this.$v.$touch()
          if (this.$v.$invalid) {
              this.submitStatus = 'ERROR'
          }
          else {    
              this.makeQuery("/portal/loginTender", { dataAuthorization: this.dataAuthorization })
              .then(res => {
                  if(res != null && res.data.session){
                      this.$store.commit('setGuidUser', res.data.userGuid )
                      this.$store.commit('setUserLogin', res.data.username )
                      this.$store.commit('setUserName', res.data.name )
                      this.$store.commit('setUserToken', res.data.session )
                      this.$store.commit('setUser', JSON.stringify(res.data.username))
                      this.$store.commit('setEmail', res.data.email)
                      this.$store.commit('setClientName', JSON.stringify(res.data.clientName))
                      this.$store.commit('setGuidClient', res.data.clientGuid)
                      this.$store.commit('setIp', this.dataAuthorization.ip)
                      this.$store.commit('setCurrentUser', res.data.clientGuid);                        
                      if (res.data.vat ) {this.$store.commit('setUserPdv', res.data.vat);}
                      if (res.data.roleAdmin == true){
                      this.$store.commit('setUserRoleAdmin', true);
                      this.$store.commit('setUserRole', "admin");
                      }
                      if (res.data.roleClient == true){
                      this.$store.commit('setUserRoleClient', true);
                      this.$store.commit('setUserRole', "client");
                      }
                      if (res.data.roleClientME == true){
                      this.$store.commit('setUserRoleUser', true);
                      this.$store.commit('setUserRole', "clientME");
                      }
                      if (res.data.roleLogist == true){
                      this.$store.commit('setUserRoleLogist', true);
                      this.$store.commit('setUserRole', "logist");
                      }
                      if ( this.isValid(res.data.image) ){                          
                      this.$store.commit('setProfilePhoto',"data:image/jpg;base64," + res.data.image);                          
                      }
                      if (this.$store.state.userToken != null) { 
                      this.$emit('loggedIn')
                      if (this.$route.params.nextUrl != null) {
                          this.$store.state.isLoading = false;
                          this.$router.push(this.$route.params.nextUrl);
                      } else {
                          this.$store.state.isLoading = false;
                          //this.$router.push('dashboard');
                          //this.$router.go(1);
                          this.$router.push({ name: 'dashboard-layout'});
                      }
                      }
                    }
                  else {
                    this.showNotification('custom-error','Authorization','Wrong password ');
                  }
                })                
            }
        },
  },
   watch: {
           
        },
};
</script>

<style scoped>
.error {
    font-size: 0.75rem;
    line-height: 1;
    display: none;
    /* margin-left: 14px; */
    margin-top: 0.6875rem;
    margin-bottom: 0.9375rem; }
.form-group--alert,
  .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out; }
  
    .form-group--success .form__label, .form-group--success .form__label--inline {
    color: #43AC6A; }
  
  .form-group--success .form-group__addon {
    color: white;
    border-color: #85d0a1;
    background: #85d0a1; }
  
  .form-group--success input,
  .form-group--success textarea,
  .form-group--success input:focus,
  .form-group--success input:hover {
    border-color: #85d0a1; }
  
  .form-group--success + .form-group__message, .form-group--success + .error {
    display: block;
    color: #73c893; }
  
  .form-group--error .form__label, .form-group--error .form__label--inline, .form-group--error .label{
    color: #f04124; 
    display: block;
    }
  
  .form-group--error .form-group__addon {
    color: white;
    border-color: #f79483;
    background: #f79483; }
  
  .form-group--error input,
  .form-group--error textarea,
  .form-group--error input:focus,
  .form-group--error input:hover {
    border-color: #f79483; }
  
  .form-group--error  .form-group__message, .form-group--error  .error  {
    display: block;
    color: #f57f6c; }
    .form-group--error label {    
    color: #f57f6c; }
  
  .form-group--alert .form__label, .form-group--alert .form__label--inline {
    color: #f08a24; }
  
  .form-group--alert .form-group__addon {
    color: white;
    border-color: #f7bd83;
    background: #f7bd83; }
  
  .form-group--alert input,
  .form-group--alert textarea,
  .form-group--alert input:focus,
  .form-group--alert input:hover {
    border-color: #f7bd83; }
  
  .form-group--alert + .form-group__message {
    display: block;
    color: #f5b06c; }
</style>


// WEBPACK FOOTER //
// src/components/forms/login.vue